var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { useLanguage } from '@base/LanguageProvider';
import { SettingType } from '@common/api';
import { isExistingListItem, isNewListItem, listItemToCellRepersentation, useCreateListItem, useDeleteListItem, useListItemsPagination, useUpdateListItem, } from '@data/cell';
import { useTagContext } from '@data/tag/tagContext';
import { getTimeDimensionTagsFromDate } from '@data/tag/tagUtil';
import { isAccountTag } from '@data/tag/types';
import { LineItemModal } from '@shared/lineitems/LineItemEditor';
import Manager from '@shared/modal/Manager';
import { NumberFormatType } from '@util/enums';
import { formatNumber } from '@util/formatNum';
import { dateToSerial, isExcelDateFormat, serialToDate } from '@util/number';
//@ts-ignore
import { useBranch } from 'baobab-react/hooks';
import React, { useMemo, useState } from 'react';
import toast from 'react-hot-toast';
import Sheet from 'sheet-happens';
import { useSetting } from '@data/hooks/settings';
import useTableCells from '@hooks/useTableCells';
import { cancel, deleteBtn, editBtn, ICON_SIZE, saveAll } from '@shared/icons/tableIcons';
import { useActiveVersions } from '@data/hooks/versions';
import { useActiveYears } from '@data/hooks/timePoints';
import { useSelectedSheetRow } from '../../data/sheetRow/sheetRowHooks';
import { useAuth } from '../../providers/AuthProvider';
var CONTAINER_STYLE = { width: '100%', position: 'relative' };
function createListItemActionCell(command) {
    var item = command.item, editListItem = command.editListItem, deleteListItem = command.deleteListItem;
    var actionCell = { items: [] };
    if (item.readonly) {
        return actionCell;
    }
    actionCell.items.push({
        x: 30,
        y: -8,
        width: ICON_SIZE,
        height: ICON_SIZE,
        content: editBtn,
        onClick: function () {
            editListItem(item);
        },
    });
    actionCell.items.push({
        x: 55,
        y: -8,
        width: ICON_SIZE,
        height: ICON_SIZE,
        content: deleteBtn,
        onClick: function () {
            deleteListItem(item);
        },
    });
    return actionCell;
}
function createNewListItemActionCell(command) {
    var saveNewListItems = command.saveNewListItems, deleteNewListItems = command.deleteNewListItems;
    var actionCell = { items: [] };
    actionCell.items.push({
        x: 30,
        y: -8,
        width: ICON_SIZE,
        height: ICON_SIZE,
        content: saveAll,
        onClick: saveNewListItems,
    });
    actionCell.items.push({
        x: 55,
        y: -8,
        width: ICON_SIZE,
        height: ICON_SIZE,
        content: cancel,
        onClick: deleteNewListItems,
    });
    return actionCell;
}
function generateColumns(dependencies) {
    var _a;
    var descriptionColumn = ((_a = dependencies === null || dependencies === void 0 ? void 0 : dependencies.user) === null || _a === void 0 ? void 0 : _a.features.canSeeListItemDescription)
        ? [
            {
                header: 'Description',
                readonly: false,
                display: function (item) {
                    var _a;
                    return (_a = item.description) !== null && _a !== void 0 ? _a : null;
                },
                edit: function (item) {
                    var _a;
                    return (_a = item.description) !== null && _a !== void 0 ? _a : '';
                },
                source: function (item) {
                    var _a;
                    return (_a = item.description) !== null && _a !== void 0 ? _a : null;
                },
                update: function (_a) {
                    var item = _a.item, value = _a.value;
                    return __assign(__assign({}, item), { description: value });
                },
            },
        ]
        : [];
    var defaultColumns = __spreadArray(__spreadArray([
        {
            header: 'Date',
            readonly: false,
            required: true,
            display: function (item) {
                return item.date ? dependencies.languageContext.formatLocaleDate(item.date) : null;
            },
            source: function (item) {
                return item.date ? item.date.toISOString() : null;
            },
            edit: function (item) {
                return item.date ? dependencies.languageContext.formatLocaleDate(item.date) : '';
            },
            update: function (_a) {
                var item = _a.item, value = _a.value;
                var internalTagsMap = dependencies.internalTagsMap;
                var newDate = dependencies.languageContext.parseLocaleDate(value);
                if (newDate === null) {
                    return item;
                }
                var updatedCell = __assign(__assign({}, item), { date: newDate });
                if (!internalTagsMap) {
                    return item;
                }
                try {
                    var _b = getTimeDimensionTagsFromDate(newDate, internalTagsMap, dependencies.financialYearStartingMonthOffset), yearTag = _b.yearTag, monthTag = _b.monthTag;
                    updatedCell.yearTag = yearTag;
                    updatedCell.monthTag = monthTag;
                    return updatedCell;
                }
                catch (error) {
                    console.error(error.message);
                    toast.error(error.message);
                    return item;
                }
            },
        },
        {
            header: 'Version',
            readonly: false,
            display: function (item) {
                return item.versionTag ? item.versionTag.name : null;
            },
            edit: function (item) {
                return item.versionTag ? item.versionTag.name : '';
            },
            source: function (item) {
                var _a, _b;
                return (_b = (_a = item.versionTag) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : null;
            },
            update: function (_a) {
                var item = _a.item, value = _a.value;
                var versionByNameMap = dependencies.versionByNameMap;
                var lowerCaseValue = value.toLowerCase();
                var versionTag = versionByNameMap === null || versionByNameMap === void 0 ? void 0 : versionByNameMap[lowerCaseValue];
                if (versionTag) {
                    return __assign(__assign({}, item), { versionTag: versionTag });
                }
                return item;
            },
        },
        {
            header: 'Variable and Dimensions',
            readonly: true,
            display: function (item) {
                var tagByIdMap = dependencies.tagByIdMap;
                if (!isExistingListItem(item) || !tagByIdMap) {
                    return null;
                }
                var tagNames = __spreadArray([
                    item.accountTag.name
                ], __read(item.dimensionTagIds.map(function (id) { var _a, _b; return (_b = (_a = tagByIdMap[id]) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : ''; })), false);
                return tagNames.join(', ');
            },
        }
    ], __read(descriptionColumn), false), [
        {
            header: 'Value',
            readonly: false,
            required: true,
            display: function (item, format) {
                var _a, _b, _c, _d;
                var accountTagFormat = (_b = (_a = item.accountTag) === null || _a === void 0 ? void 0 : _a.numberFormat) === null || _b === void 0 ? void 0 : _b.format;
                return accountTagFormat !== undefined
                    ? isExcelDateFormat(accountTagFormat)
                        ? dependencies.languageContext.excelLocalizedDateFormat((_c = item.value) !== null && _c !== void 0 ? _c : null, accountTagFormat)
                        : dependencies.languageContext.excelLocalizedNumberFormat((_d = item.value) !== null && _d !== void 0 ? _d : null, accountTagFormat)
                    : formatNumber(item.value, format);
            },
            edit: function (item) {
                var _a, _b;
                if (isExcelDateFormat((_b = (_a = item.accountTag) === null || _a === void 0 ? void 0 : _a.numberFormat) === null || _b === void 0 ? void 0 : _b.format) &&
                    item.value !== undefined &&
                    item.value !== null) {
                    var date = serialToDate(item.value);
                    if (date === null) {
                        return '';
                    }
                    return dependencies.languageContext.formatLocaleDate(date);
                }
                return item.value ? formatNumber(item.value, NumberFormatType.UNFORMATTED) : '';
            },
            source: function (item) {
                var _a;
                return (_a = item.value) !== null && _a !== void 0 ? _a : null;
            },
            update: function (_a) {
                var _b, _c;
                var item = _a.item, value = _a.value;
                if (!value) {
                    return __assign(__assign({}, item), { value: null });
                }
                var newValue = Number(value);
                if (((_c = (_b = item.accountTag) === null || _b === void 0 ? void 0 : _b.numberFormat) === null || _c === void 0 ? void 0 : _c.format) &&
                    isExcelDateFormat(item.accountTag.numberFormat.format) &&
                    isNaN(newValue)) {
                    var date = dependencies.languageContext.parseLocaleDate(value);
                    if (date === null) {
                        return __assign(__assign({}, item), { value: null });
                    }
                    return __assign(__assign({}, item), { value: dateToSerial(date) });
                }
                if (isNaN(newValue)) {
                    return item;
                }
                return __assign(__assign({}, item), { value: newValue });
            },
        },
        {
            header: 'Action',
            readonly: true,
            display: function (item) {
                var newListItems = dependencies.newListItems, editListItem = dependencies.editListItem, deleteListItem = dependencies.deleteListItem, saveNewListItems = dependencies.saveNewListItems, deleteNewListItems = dependencies.deleteNewListItems;
                var lastItem = newListItems[newListItems.length - 1];
                if (item && isExistingListItem(item)) {
                    return createListItemActionCell({ item: item, editListItem: editListItem, deleteListItem: deleteListItem });
                }
                if (lastItem && lastItem === item) {
                    return createNewListItemActionCell({ saveNewListItems: saveNewListItems, deleteNewListItems: deleteNewListItems });
                }
                return null;
            },
        },
    ], false);
    return defaultColumns;
}
function useListItemTableData(page, newListItems, editListItem, deleteListItem, deleteNewListItems, saveNewListItems, languageContext, dependencies) {
    var tagByIdMap = dependencies.tagByIdMap, internalTagsMap = dependencies.internalTagsMap, versionByNameMap = dependencies.versionByNameMap, financialYearStartingMonthOffset = dependencies.financialYearStartingMonthOffset, user = dependencies.user;
    var listItemPages = useListItemsPagination(page, dependencies);
    var columns = useMemo(function () {
        return generateColumns({
            editListItem: editListItem,
            deleteListItem: deleteListItem,
            saveNewListItems: saveNewListItems,
            deleteNewListItems: deleteNewListItems,
            languageContext: languageContext,
            newListItems: newListItems,
            tagByIdMap: tagByIdMap,
            internalTagsMap: internalTagsMap,
            versionByNameMap: versionByNameMap,
            financialYearStartingMonthOffset: financialYearStartingMonthOffset,
            user: user,
        });
    }, [newListItems, tagByIdMap, editListItem, deleteListItem, saveNewListItems, deleteNewListItems, languageContext]);
    var hasData = !!listItemPages.data;
    return {
        loading: listItemPages.isLoading,
        columns: columns,
        listItems: listItemPages.data,
        error: listItemPages.error instanceof Error ? listItemPages.error : undefined,
        hasData: hasData,
    };
}
function getCurrentListItem(command) {
    var _a, _b, _c;
    var rowIndex = command.rowIndex, listItems = command.listItems, newListItems = command.newListItems, updatedNewItems = command.updatedNewItems, updatedExistingItems = command.updatedExistingItems, accountTag = command.accountTag;
    var listItem = (_a = updatedExistingItems.get(rowIndex)) !== null && _a !== void 0 ? _a : listItems === null || listItems === void 0 ? void 0 : listItems[rowIndex];
    var listItemsLength = (_b = listItems === null || listItems === void 0 ? void 0 : listItems.length) !== null && _b !== void 0 ? _b : 0;
    var newListItemIndex = rowIndex - listItemsLength;
    var newListItem = (_c = newListItems[newListItemIndex]) !== null && _c !== void 0 ? _c : updatedNewItems.get(rowIndex);
    if (listItem) {
        return listItem;
    }
    if (newListItem) {
        return __assign(__assign({}, newListItem), { accountTag: accountTag });
    }
    return { accountTag: accountTag };
}
function getTargetItem(command) {
    var _a, _b;
    var newListItems = command.newListItems, listItems = command.listItems, rowIndex = command.rowIndex;
    var listItemsLength = (_a = listItems === null || listItems === void 0 ? void 0 : listItems.length) !== null && _a !== void 0 ? _a : 0;
    var newItemIndex = rowIndex - listItemsLength;
    var targetItem = (_b = listItems === null || listItems === void 0 ? void 0 : listItems[rowIndex]) !== null && _b !== void 0 ? _b : newListItems === null || newListItems === void 0 ? void 0 : newListItems[newItemIndex];
    return targetItem;
}
export function ListItemTable(_a) {
    var _b, _c, _d;
    var height = _a.height, format = _a.format, invalidate = _a.invalidate;
    var languageContext = useLanguage();
    var L = languageContext.L;
    var user = useAuth().user;
    var _e = __read(useState([]), 2), newListItems = _e[0], setNewListItems = _e[1];
    var activeVersions = useActiveVersions();
    var activeYears = useActiveYears();
    var page = useBranch({
        page: ['state', 'lineItemsPagination', 'page'],
    }).page;
    var selectedSheetRow = useSelectedSheetRow();
    var tagData = useTagContext().tagData;
    var userSettings = useAuth().settings;
    var financialYearStartingMonthSetting = useSetting(SettingType.FinancialYearStartingMonth);
    var dependencies = {
        user: user,
        userSettings: userSettings,
        internalTagsMap: tagData.internalTagsMap,
        tagByIdMap: tagData.tagById,
        selectedSheetRow: selectedSheetRow,
        activeVersions: activeVersions,
        activeYears: activeYears,
        versionByNameMap: tagData.versionTagMap,
        financialYearStartingMonthOffset: +((_b = financialYearStartingMonthSetting === null || financialYearStartingMonthSetting === void 0 ? void 0 : financialYearStartingMonthSetting.value) !== null && _b !== void 0 ? _b : 1) - 1,
    };
    var accountTagInfo = (_d = (_c = selectedSheetRow === null || selectedSheetRow === void 0 ? void 0 : selectedSheetRow.allTags) === null || _c === void 0 ? void 0 : _c.find) === null || _d === void 0 ? void 0 : _d.call(_c, function (t) {
        var tag = tagData.tagById[t.id];
        return tag && isAccountTag(tag);
    });
    var accountTag = !!accountTagInfo ? tagData.tagById[accountTagInfo === null || accountTagInfo === void 0 ? void 0 : accountTagInfo.id] : undefined;
    var _f = useListItemTableData(page, newListItems, editListItem, deleteListItem, deleteNewListItems, saveNewListItems, languageContext, dependencies), columns = _f.columns, listItems = _f.listItems, hasData = _f.hasData, error = _f.error, loading = _f.loading;
    var updateListItemMutation = useUpdateListItem(page, dependencies);
    var deleteListItemMutation = useDeleteListItem(page, dependencies);
    var createListitemMutation = useCreateListItem(page, dependencies);
    var _g = useTableCells([200]), onCellWidthChange = _g.onCellWidthChange, onCellHeightChange = _g.onCellHeightChange, cellWidth = _g.cellWidth, cellHeight = _g.cellHeight;
    function editListItem(cell) {
        Manager.renderModal(React.createElement(LineItemModal, { lineItemCell: listItemToCellRepersentation(cell) }));
    }
    function saveNewListItems() {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function () {
            var selectedSheetRowDimensionTags, newListItemsWithTags, _c, _d, newListItem, e_1_1, error_1;
            var e_1, _e;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        selectedSheetRowDimensionTags = (_b = (_a = selectedSheetRow === null || selectedSheetRow === void 0 ? void 0 : selectedSheetRow.allTags) === null || _a === void 0 ? void 0 : _a.filter(function (t) { return t.id !== (accountTag === null || accountTag === void 0 ? void 0 : accountTag.id); }).map(function (t) { return t.id; })) !== null && _b !== void 0 ? _b : [];
                        newListItemsWithTags = newListItems.map(function (nli) { return (__assign(__assign({}, nli), { dimensionTagIds: selectedSheetRowDimensionTags })); });
                        if (!newListItemsWithTags.every(isNewListItem)) {
                            toast.error(L('Incomplete list item data'));
                            return [2 /*return*/];
                        }
                        _f.label = 1;
                    case 1:
                        _f.trys.push([1, 10, , 11]);
                        _f.label = 2;
                    case 2:
                        _f.trys.push([2, 7, 8, 9]);
                        _c = __values(newListItemsWithTags), _d = _c.next();
                        _f.label = 3;
                    case 3:
                        if (!!_d.done) return [3 /*break*/, 6];
                        newListItem = _d.value;
                        return [4 /*yield*/, createListitemMutation.mutateAsync(newListItem)];
                    case 4:
                        _f.sent();
                        _f.label = 5;
                    case 5:
                        _d = _c.next();
                        return [3 /*break*/, 3];
                    case 6: return [3 /*break*/, 9];
                    case 7:
                        e_1_1 = _f.sent();
                        e_1 = { error: e_1_1 };
                        return [3 /*break*/, 9];
                    case 8:
                        try {
                            if (_d && !_d.done && (_e = _c.return)) _e.call(_c);
                        }
                        finally { if (e_1) throw e_1.error; }
                        return [7 /*endfinally*/];
                    case 9: return [3 /*break*/, 11];
                    case 10:
                        error_1 = _f.sent();
                        console.error(error_1);
                        toast.error(L('Failed to save list items'));
                        return [2 /*return*/];
                    case 11:
                        deleteNewListItems();
                        invalidate === null || invalidate === void 0 ? void 0 : invalidate();
                        return [2 /*return*/];
                }
            });
        });
    }
    function deleteNewListItems() {
        setNewListItems([]);
    }
    function deleteListItem(item) {
        deleteListItemMutation.mutate(item.id, {
            onSuccess: function () {
                invalidate === null || invalidate === void 0 ? void 0 : invalidate();
            },
        });
    }
    function columnHeaders(x) {
        var header = columns[x] ? L(columns[x].header) : '';
        return header;
    }
    function editData(x, y) {
        var _a;
        var targetItem = getTargetItem({ newListItems: newListItems, listItems: listItems, rowIndex: y });
        var editFn = (_a = columns[x]) === null || _a === void 0 ? void 0 : _a.edit;
        if (targetItem && editFn) {
            return editFn(targetItem);
        }
        return targetItem && editFn ? editFn(targetItem) : '';
    }
    function cellStyle(x, y) {
        var style = { textAlign: 'left', fontFamily: 'Inter', fontSize: 12 };
        var column = columns[x];
        var targetItem = getTargetItem({ newListItems: newListItems, listItems: listItems, rowIndex: y });
        if ((targetItem && targetItem.readonly) || (!accountTag && !isNewListItem(targetItem)) || !column) {
            style.fillColor = '#00000009';
            return style;
        }
        var sourceFn = column === null || column === void 0 ? void 0 : column.source;
        var sourceValue = sourceFn && targetItem ? sourceFn(targetItem) : null;
        var isRequiredCellEmpty = targetItem && !isExistingListItem(targetItem) && (column === null || column === void 0 ? void 0 : column.required) && !sourceValue;
        if (isRequiredCellEmpty) {
            style.fillColor = '#e74d3c25';
        }
        return style;
    }
    function displayData(x, y) {
        var _a, _b;
        var targetItem = getTargetItem({ newListItems: newListItems, listItems: listItems, rowIndex: y });
        var displayFn = (_a = columns === null || columns === void 0 ? void 0 : columns[x]) === null || _a === void 0 ? void 0 : _a.display;
        return targetItem ? (_b = displayFn === null || displayFn === void 0 ? void 0 : displayFn(targetItem, format)) !== null && _b !== void 0 ? _b : null : null;
    }
    function sourceData(x, y) {
        var _a;
        var targetItem = getTargetItem({ newListItems: newListItems, listItems: listItems, rowIndex: y });
        var sourceFn = (_a = columns[x]) === null || _a === void 0 ? void 0 : _a.source;
        return targetItem && sourceFn ? sourceFn(targetItem) : null;
    }
    function isReadOnly(x, y) {
        var column = columns[x];
        var targetItem = getTargetItem({ newListItems: newListItems, listItems: listItems, rowIndex: y });
        return ((targetItem === null || targetItem === void 0 ? void 0 : targetItem.readonly) ||
            (!accountTag && !isNewListItem(targetItem)) ||
            !listItems ||
            !column ||
            column.readonly);
    }
    function addNewItems(updatedNewItems) {
        var e_2, _a;
        var _b;
        var copy = __spreadArray([], __read(newListItems), false);
        var updatedMap = new Map(updatedNewItems);
        var listItemsLength = (_b = listItems === null || listItems === void 0 ? void 0 : listItems.length) !== null && _b !== void 0 ? _b : 0;
        try {
            for (var updatedNewItems_1 = __values(updatedNewItems), updatedNewItems_1_1 = updatedNewItems_1.next(); !updatedNewItems_1_1.done; updatedNewItems_1_1 = updatedNewItems_1.next()) {
                var _c = __read(updatedNewItems_1_1.value, 2), rowIndex = _c[0], newItem = _c[1];
                var newItemIndex = rowIndex - listItemsLength;
                if (copy[newItemIndex]) {
                    copy[newItemIndex] = newItem;
                    updatedMap.delete(rowIndex);
                }
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (updatedNewItems_1_1 && !updatedNewItems_1_1.done && (_a = updatedNewItems_1.return)) _a.call(updatedNewItems_1);
            }
            finally { if (e_2) throw e_2.error; }
        }
        setNewListItems(__spreadArray(__spreadArray([], __read(copy), false), __read(updatedMap.values()), false));
    }
    function onChange(changes) {
        return __awaiter(this, void 0, void 0, function () {
            var updatedNewItems, updatedExistingItems, changes_1, changes_1_1, _a, x, y, value, column, updateFn, currentItem, updatedItem, _b, _c, item, e_3_1;
            var e_4, _d, e_3, _e;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        updatedNewItems = new Map();
                        updatedExistingItems = new Map();
                        try {
                            for (changes_1 = __values(changes), changes_1_1 = changes_1.next(); !changes_1_1.done; changes_1_1 = changes_1.next()) {
                                _a = changes_1_1.value, x = _a.x, y = _a.y, value = _a.value;
                                column = columns[x];
                                updateFn = column === null || column === void 0 ? void 0 : column.update;
                                currentItem = getCurrentListItem({
                                    rowIndex: y,
                                    newListItems: newListItems,
                                    updatedNewItems: updatedNewItems,
                                    updatedExistingItems: updatedExistingItems,
                                    listItems: listItems,
                                    accountTag: accountTag,
                                });
                                if (!updateFn || column.readonly || currentItem.readonly) {
                                    continue;
                                }
                                updatedItem = updateFn({ item: currentItem, value: value });
                                isExistingListItem(updatedItem)
                                    ? updatedExistingItems.set(y, updatedItem)
                                    : updatedNewItems.set(y, updatedItem);
                            }
                        }
                        catch (e_4_1) { e_4 = { error: e_4_1 }; }
                        finally {
                            try {
                                if (changes_1_1 && !changes_1_1.done && (_d = changes_1.return)) _d.call(changes_1);
                            }
                            finally { if (e_4) throw e_4.error; }
                        }
                        _f.label = 1;
                    case 1:
                        _f.trys.push([1, 6, 7, 8]);
                        _b = __values(updatedExistingItems.values()), _c = _b.next();
                        _f.label = 2;
                    case 2:
                        if (!!_c.done) return [3 /*break*/, 5];
                        item = _c.value;
                        return [4 /*yield*/, updateListItemMutation.mutateAsync(item)];
                    case 3:
                        _f.sent();
                        _f.label = 4;
                    case 4:
                        _c = _b.next();
                        return [3 /*break*/, 2];
                    case 5: return [3 /*break*/, 8];
                    case 6:
                        e_3_1 = _f.sent();
                        e_3 = { error: e_3_1 };
                        return [3 /*break*/, 8];
                    case 7:
                        try {
                            if (_c && !_c.done && (_e = _b.return)) _e.call(_b);
                        }
                        finally { if (e_3) throw e_3.error; }
                        return [7 /*endfinally*/];
                    case 8:
                        addNewItems(updatedNewItems);
                        return [2 /*return*/];
                }
            });
        });
    }
    return (React.createElement(ListItemTableView, { data: { error: error, hasData: hasData, loading: loading }, state: { height: height, cellHeight: cellHeight, cellWidth: cellWidth }, cellStyle: cellStyle, onCellWidthChange: onCellWidthChange, onCellHeightChange: onCellHeightChange, columnHeaders: columnHeaders, displayData: displayData, editData: editData, isReadOnly: isReadOnly, onChange: onChange, sourceData: sourceData }));
}
export function ListItemTableView(_a) {
    var state = _a.state, data = _a.data, cellStyle = _a.cellStyle, columnHeaders = _a.columnHeaders, displayData = _a.displayData, editData = _a.editData, isReadOnly = _a.isReadOnly, onChange = _a.onChange, sourceData = _a.sourceData, onCellHeightChange = _a.onCellHeightChange, onCellWidthChange = _a.onCellWidthChange;
    var L = useLanguage().L;
    var loading = data.loading, error = data.error, hasData = data.hasData;
    var cellHeight = state.cellHeight, cellWidth = state.cellWidth, height = state.height;
    var style = __assign(__assign({}, CONTAINER_STYLE), { height: height });
    if (hasData) {
        return (React.createElement("div", { style: style },
            React.createElement(Sheet, { columnHeaders: columnHeaders, columnHeaderStyle: { fontFamily: 'Inter', fontSize: 12 }, displayData: displayData, editData: editData, readOnly: isReadOnly, sourceData: sourceData, onChange: onChange, cellStyle: cellStyle, cellWidth: cellWidth, cellHeight: cellHeight, onCellWidthChange: onCellWidthChange, onCellHeightChange: onCellHeightChange })));
    }
    if (error) {
        React.createElement("div", { style: style },
            L('An error has occured'),
            ": ",
            L(error.message));
    }
    return React.createElement("div", { style: style }, L('Loading data...'));
}
